import { Skeleton } from '../ui/skeleton';

/**
 * PageSkeleton — Gestandaardiseerde laadweergave
 * Toont altijd paginatitel en herkenbare structuur zodat de gebruiker weet dat de klik is verwerkt.
 *
 * @param {string} title - Paginatitel (altijd tonen)
 * @param {boolean} showKpi - Toon KPI skeleton rij
 * @param {boolean} showTable - Toon tabel skeleton
 * @param {boolean} showCards - Toon kaart grid skeleton
 * @param {React.ReactNode} tabs - Optionele SectionTabs component
 */
export const PageSkeleton = ({ title = 'Laden...', showKpi = false, showTable = false, showCards = false, tabs }) => (
  <div className="min-h-screen" data-testid="page-skeleton">
    {tabs}
    <div className="px-6 py-4 border-b border-[#E5E7EB] bg-white">
      <h1 className="text-2xl font-semibold text-[#111827]">{title}</h1>
      <Skeleton className="h-4 w-64 mt-1 rounded" />
    </div>
    {showKpi && (
      <div className="px-6 py-4 border-b border-[#F3F4F6] bg-white">
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-6">
          {[1, 2, 3, 4].map(i => (
            <div key={i} className="space-y-2">
              <Skeleton className="h-3 w-20 rounded" />
              <Skeleton className="h-7 w-16 rounded" />
              <Skeleton className="h-3 w-24 rounded" />
            </div>
          ))}
        </div>
      </div>
    )}
    {showTable && (
      <div className="bg-white">
        <div className="px-6 py-3 border-b border-[#F3F4F6]">
          <Skeleton className="h-10 w-80 rounded-lg" />
        </div>
        <div className="divide-y divide-[#F3F4F6]">
          {[1, 2, 3, 4, 5].map(i => (
            <div key={i} className="px-6 py-4 flex items-center gap-4">
              <Skeleton className="h-4 w-4 rounded" />
              <Skeleton className="h-4 flex-1 max-w-sm rounded" />
              <Skeleton className="h-5 w-16 rounded-md" />
              <Skeleton className="h-5 w-20 rounded-md" />
              <Skeleton className="h-4 w-12 rounded" />
              <Skeleton className="h-4 w-24 rounded" />
            </div>
          ))}
        </div>
      </div>
    )}
    {showCards && (
      <div className="px-6 py-6">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {[1, 2, 3, 4, 5, 6].map(i => (
            <Skeleton key={i} className="h-32 rounded-xl" />
          ))}
        </div>
      </div>
    )}
    {!showTable && !showCards && (
      <div className="px-6 py-6 space-y-4">
        <Skeleton className="h-24 w-full rounded-xl" />
        <div className="grid grid-cols-5 gap-3">
          {[1, 2, 3, 4, 5].map(i => <Skeleton key={i} className="h-24 rounded-xl" />)}
        </div>
        <Skeleton className="h-64 w-full rounded-xl" />
      </div>
    )}
  </div>
);
